import { render, staticRenderFns } from "./HAkPrintPage2.vue?vue&type=template&id=bf8e428e"
import script from "./HAkPrintPage2.vue?vue&type=script&lang=js"
export * from "./HAkPrintPage2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports